<!-- <footer> -->
<!-- <div class="start-journey text-center">
  <a href="#" class="btn"> <span>Start your journey</span></a>
</div>
<div class="footer-wrap">
  <div class="container">
    <div class="row">
      <div class="col-md-1 col-lg-2">
        <a href="#" class="footer-logo">
          <img src="assets/images/footer-logo.png" alt="footer-logo">
        </a>
      </div>
      <div class="col-md-2 little-sift">
        <h6 class="list-title">My Life Well</h6>
        <ul class="footer-list">
          <li><a href="/about-us" class="footer-link">About My Tripwell</a></li>
          <li><a href="javascript:void(0)" class="footer-link">Devices</a></li>
          <li><a href="#" class="footer-link">Support center</a></li>
          <li><a href="/site-map" class="footer-link">Site Map</a></li>
          <li><a href="/privacy_policy" class="footer-link">Privacy policy</a></li>
          <li><a href="/terms-conditions" class="footer-link">Terms & conditions</a></li>
        </ul>

      </div>
      <div class="col-md-3 little-sift"> -->
<!--          <h6 class="list-title">Explore</h6>-->
<!--          <ul class="footer-list">-->
<!--            <li><a href="#" class="footer-link">Online Yoga</a></li>-->
<!--            <li><a href="#" class="footer-link">Online Meditation</a></li>-->
<!--            <li><a href="#" class="footer-link">Online Pilates</a></li>-->
<!--            <li><a href="#" class="footer-link">Cooking</a></li>-->
<!--            <li><a href="#" class="footer-link">Nutrition</a></li>-->
<!--            <li><a href="#" class="footer-link">Mindfulness</a></li>-->
<!--            <li><a href="#" class="footer-link">Stress management</a></li>-->
<!--            <li><a href="#" class="footer-link">Relationship management</a></li>-->
<!--          </ul>-->
<!-- </div>
<div class="col-md-2 col-lg-1 little-sift">
  <h6 class="list-title">Content</h6>
  <ul class="footer-list"> -->
<!--            <li><a href="#" class="footer-link">Programs</a></li>-->
<!--            <li><a href="/digital/instructors/" class="footer-link">Teachers</a></li>-->
<!--            <li><a href="#" class="footer-link">Styles</a></li>-->
<!--            <li><a href="#" class="footer-link">Courses</a></li>-->
<!-- </ul>
</div>
<div class="col-md-4">
<h6 class="list-title">Blog</h6>
<ul class="footer-list">
  <li><a href="javascript:void(0)" class="footer-link">My Tripwell Blog</a></li>
</ul>
<div class="footer-newsletter">
  <h5>Join our newsletter</h5>
  <p>Get My Tripwell’s best free videos, helpful articles, and exclusive offers every week, straight to your Inbox</p>
  <div class="email-now">
    <input type="text" placeholder="email address"/>
  </div>
  <button class="btn signup-free">Sign up for free <i class="icon-arrow"></i></button>
  <ul class="social-list text-center">
    <li><a target="_blank" href="https://www.facebook.com/mytripwell"><i class="icon-facebook"></i></a></li>
    <li><a target="_blank" href="https://twitter.com/mytripwell"><i class="icon-twitter"></i></a></li>
    <li><a target="_blank" href="https://www.instagram.com/mytripwell"><i class="icon-insta"></i></a></li>
  </ul>
</div>
</div>
</div>
<p class="copy-rgt text-center text-md-left">Copyright &copy; 2020 My Tripwell, Inc.</p>
</div>
</div>
</footer> -->
<footer class="footer" id="footer">
  <div class="container clearfix">
    <div class="footer-logo">
      <a href="index.html">
        <img alt="" src="https://www.mylifewell.com/assets/images/logo/300.png">
      </a>
      <h2 >My LifeWell</h2>
      <p >© Copyright 2021 DC Wellness, Inc.</p>
      <p > All right reserved. Terms &amp; Policy </p>
    </div>
    <div  class="footer-nav clearfix">
      <ul >
        <li >
          <a  href="/about-us"> About Us </a>
        </li>
        <li >
          <a  href="/career"> Careers </a>
        </li>
        <li >
          <a  href="/partners"> Partners </a>
        </li>
        <li >
          <a href="/workwell">Corporate Wellness</a>
        </li>
        <li >
          <a  href="/contact"> Contact Us </a>
        </li>


      </ul>
      <ul >
        <li >
          <a  href="https://www.mylifewell.com/blogs/" target="_blank">
            Blogs 
           </a>
        </li>
        <li >
          <a  href="/terms-conditions"> Terms &amp; Conditions </a>
        </li>
        <li >
          <a  href="/privacy_policy"> Privacy Policy </a>
        </li>
        <li ></li>
        <li *ngIf="">
          <a  href="https://www.travelsafe.com/agent-insurance-plans/?a=2ceed978-ad9f-4213-b2a3-0fd557608efc" target="_blank"> Travel Insurance </a>
        </li>
        <li >
          <a  href="/faqs"> FAQs </a>
        </li>
        <li >
          <a  href="/site-map"> Site Map </a>
        </li>
      </ul>
    </div>
    <div  class="contact-media">
      <div  class="contact">
        <h2 > Contact us !</h2>
        <a  href="mailto:info@mylifewell.com"> Email - info@mylifewell.com </a>
        <a  href="tel:18882103805"> Ph - 888-210-3805.</a>
      </div>
      <div  class="media">
        <h2 > We're social. Join us!</h2>
        <ul class="text-center">
          <li >
            <a  href="https://www.facebook.com/mylifewell1" target="_blank">
              <i  class="icon-fb">&nbsp;</i>
            </a>
          </li>
          <li >
            <a  href="https://twitter.com/mylifewell_" target="_blank"><i  class="icon-twit">&nbsp;</i></a>
          </li>
          <li >
            <a  href="https://www.instagram.com/mylifewell_/" target="_blank"><i  class="icon-ins">&nbsp;</i></a>
          </li>
          <li >
            <a class="social-youtube"  href="https://www.youtube.com/channel/UCCFC7tdfd3MGjNE4BhMhbRQ?view_as=subscriber" target="_blank"><img src="assets/images/youtube.svg" alt="youtube"></a>
          </li>
          <li >
            <a class="social-pintrest"  href="https://www.pinterest.com/MyLifeWell/" target="_blank"><img src="assets/images/pintrest.svg" alt="pintrest"></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!--  <script id="CookieDeclaration" src="https://consent.cookiebot.com/d045ae88-11f8-4bf9-9f7d-3a136654c9d5/cd.js" type="text/javascript" async></script>-->
</footer>
